import * as tslib_1 from "tslib";
import { Base } from "../../components/base-component";
import { AnalyticsService } from "../../services/analytics.service";
import "./form-item-mail-form-v2.component.scss";
var FormItemMailFormV2 = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemMailFormV2, _super);
    function FormItemMailFormV2(element) {
        return _super.call(this, element) || this;
    }
    FormItemMailFormV2.prototype.init = function () {
        this.applyForm = this.element.querySelector("form");
        this.applyFormSubmit = Array.from(this.element.querySelectorAll(".js-apply-now__button"));
        this.subjectField = this.element.querySelector("input[name=subject]");
        this.emailField = this.element.querySelector("input[name=email]");
        this.recipientField = this.element.querySelector("input[name=recipient]");
        this.showMoreBtn = this.element.querySelector(".data-privacy-collapse-show");
        this.showLessBtn = this.element.querySelector(".data-privacy-collapse-hide");
        this.dataPrivacyDetailArea = this.element.querySelector(".data-privacy-detail");
        this.dataSharingGroupHideBtn = this.element.querySelector(".data-sharing-group-hide-btn");
        this.dataSharingGroupShowBtn = this.element.querySelector(".data-sharing-group-show-btn");
        this.dataSharingGroupTextArea = this.element.querySelector(".data-sharing-group");
        this.dataSharing3rdPartyShowBtn = this.element.querySelector(".data-sharing-3rd-party-show-btn");
        this.dataSharing3rdPartyHideBtn = this.element.querySelector(".data-sharing-3rd-party-hide-btn");
        this.dataSharing3rdPartyTextArea = this.element.querySelector(".data-sharing-3rd-party");
        this.dataSharingBoardersHideBtn = this.element.querySelector(".data-sharing-boarders-hide-btn");
        this.dataSharingBoardersShowBtn = this.element.querySelector(".data-sharing-boarders-show-btn");
        this.dataSharingBoardersTextArea = this.element.querySelector(".data-sharing-boarders");
        this.naturalResources = this.element.querySelector(".js-help-required");
        if (this.naturalResources) {
            this.updateEmailForNaturalResources(this.naturalResources.value);
        }
        this.naturalResourcesProvinces = this.element.querySelector(".js-help-required-province");
        this.naturalResourcesTypeOfSolution = this.element.querySelector(".js-help-required-tos");
        this.naturalResourcesTown = this.element.querySelector(".js-help-required-town");
        if (this.naturalResources &&
            this.naturalResourcesProvinces &&
            this.naturalResourcesTypeOfSolution &&
            this.naturalResourcesTown) {
            this.updateProvincesAndToSForNaturalResources(this.naturalResources.value);
        }
        this.estateAdministration =
            this.element.querySelector(".js-estate-required");
        if (this.estateAdministration) {
            this.updateEmailForEstateAdministration(this.estateAdministration.value);
        }
        this.trust = this.element.querySelector(".js-trust-required");
        if (this.trust) {
            this.updateEmailForTrust(this.trust.value);
        }
        this.wills = this.element.querySelector(".js-wills-required");
        if (this.wills) {
            this.updateEmailForWills(this.wills.value);
        }
        this.queryTypeCompliments = this.element.querySelector(".js-form-item-compliments-enquiryType");
        if (this.queryTypeCompliments) {
            this.updateComplimentsEmail();
            var textAreaMessage = this.element.querySelector("textarea[name=message]");
            if (textAreaMessage) {
                textAreaMessage.setAttribute("maxlength", "500");
            }
        }
        this.feedbackTypeSelect = this.element.querySelector(".js-form-item-compliments-feedback");
        if (this.feedbackTypeSelect) {
            this.populateFeedbackTypeData();
            this.populateFeedBackType();
        }
        this.feedbackTypeSubSelect = this.element.querySelector(".js-form-item-compliments-feedback-category");
        if (this.feedbackTypeSubSelect) {
            this.resetSubSelect();
        }
        this.feedbackTypeSubSubSelect = this.element.querySelector(".js-form-item-compliments-feedback-sub-category");
        if (this.feedbackTypeSubSubSelect) {
            this.resetSubSubSelect();
        }
        this.cashSolutionsProvince = this.element.querySelector(".js-cashSolutions__province");
        if (this.cashSolutionsProvince) {
            this.updateCashSolutionsEmail();
        }
        this.debtCareAssistance = this.element.querySelector(".js-debtCareCenter__assistance");
        if (this.debtCareAssistance) {
            this.updateDebtCareEmailAddress();
        }
    };
    FormItemMailFormV2.prototype.bindEvents = function () {
        var _this = this;
        this.applyFormSubmit.map(function (item) {
            return item.addEventListener("click", function (event) {
                var _button = event.target;
                var _form = _button.closest("form");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.submitForm(_form);
                }
            });
        });
        this.showLessBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.showLessBtn.setAttribute("hidden", "true");
            _this.showMoreBtn.removeAttribute("hidden");
            _this.dataPrivacyDetailArea.setAttribute("hidden", "true");
        });
        this.showMoreBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.showMoreBtn.setAttribute("hidden", "true");
            _this.showLessBtn.removeAttribute("hidden");
            _this.dataPrivacyDetailArea.removeAttribute("hidden");
        });
        this.dataSharingGroupHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.setAttribute("hidden", "true");
            _this.dataSharingGroupHideBtn.setAttribute("hidden", "true");
            _this.dataSharingGroupShowBtn.removeAttribute("hidden");
        });
        this.dataSharingGroupShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.removeAttribute("hidden");
            _this.dataSharingGroupHideBtn.removeAttribute("hidden");
            _this.dataSharingGroupShowBtn.setAttribute("hidden", "true");
        });
        this.dataSharing3rdPartyHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.setAttribute("hidden", "true");
            _this.dataSharing3rdPartyShowBtn.removeAttribute("hidden");
            _this.dataSharing3rdPartyHideBtn.setAttribute("hidden", "true");
        });
        this.dataSharing3rdPartyShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.removeAttribute("hidden");
            _this.dataSharing3rdPartyHideBtn.removeAttribute("hidden");
            _this.dataSharing3rdPartyShowBtn.setAttribute("hidden", "true");
        });
        this.dataSharingBoardersShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.removeAttribute("hidden");
            _this.dataSharingBoardersShowBtn.setAttribute("hidden", "true");
            _this.dataSharingBoardersHideBtn.removeAttribute("hidden");
        });
        this.dataSharingBoardersHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.setAttribute("hidden", "true");
            _this.dataSharingBoardersHideBtn.setAttribute("hidden", "true");
            _this.dataSharingBoardersShowBtn.removeAttribute("hidden");
        });
        if (this.naturalResources) {
            this.naturalResources.addEventListener("change", function () {
                _this.updateEmailForNaturalResources(_this.naturalResources.value);
            });
        }
        if (this.estateAdministration) {
            this.estateAdministration.addEventListener("change", function () {
                _this.updateEmailForEstateAdministration(_this.estateAdministration.value);
            });
        }
        if (this.trust) {
            this.trust.addEventListener("change", function () {
                _this.updateEmailForTrust(_this.trust.value);
            });
        }
        if (this.wills) {
            this.wills.addEventListener("change", function () {
                _this.updateEmailForWills(_this.wills.value);
            });
        }
        if (this.queryTypeCompliments) {
            this.queryTypeCompliments.addEventListener("change", function (pEvent) {
                _this.updateComplimentsEmail();
            });
        }
        if (this.feedbackTypeSelect) {
            this.feedbackTypeSelect.addEventListener("change", function () {
                _this.resetSubSelect();
                _this.resetSubSubSelect();
                _this.populateSubFeedBackType(_this.feedbackTypeSelect.value);
            });
        }
        if (this.feedbackTypeSubSelect) {
            this.feedbackTypeSubSelect.addEventListener("change", function () {
                _this.resetSubSubSelect();
                _this.populateSubSubFeedBackType(_this.feedbackTypeSubSelect.value);
            });
        }
        if (this.feedbackTypeSubSubSelect) {
            this.resetSubSubSelect();
        }
        if (this.cashSolutionsProvince) {
            this.cashSolutionsProvince.addEventListener("change", function (pEvent) {
                _this.updateCashSolutionsEmail();
            });
        }
        if (this.debtCareAssistance) {
            this.debtCareAssistance.addEventListener("change", function (pEvent) {
                _this.updateDebtCareEmailAddress();
            });
        }
        if (this.applyForm) {
            var _formFields = Array.from(this.applyForm.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // This adds slashes to the business registration number
        var businessReg = this.element.querySelector(".mail-form__busReg-Number");
        if (businessReg) {
            businessReg.addEventListener("input", function (event) {
                if (event.inputType !== "deleteContentBackward" &&
                    event.inputType !== "deleteContentForward") {
                    var reg = event.target.value;
                    event.target.value =
                        _this.validationService.formatBusinessReg(reg);
                }
            });
            businessReg.addEventListener("blur", function (event) {
                var reg = event.target.value;
                event.target.value =
                    _this.validationService.formatExpression(reg);
            });
        }
        // Reset the form
        this.applyForm.addEventListener("custom_form_reset_event", function (e) {
            _this.resetForm();
        }, false);
    };
    FormItemMailFormV2.prototype.resetForm = function () {
        if (this.applyForm) {
            this.applyForm.reset();
            var formContainerLoader = this.element.querySelector(".form__loader--container");
            var formContainerFields = this.element.querySelector(".form__fields--container");
            var formContainerThankyou = this.element.querySelector(".form__thankyou--container");
            formContainerThankyou.classList.remove("active");
            formContainerFields.classList.remove("hidden");
            var _complaintsProcessWrap = this.element.querySelector(".complaints-process-wrapper");
            if (_complaintsProcessWrap) {
                _complaintsProcessWrap.classList.add("form__group--hidden");
            }
            this.resetSubSelect();
            this.resetSubSubSelect();
        }
    };
    FormItemMailFormV2.prototype.updateComplimentsEmail = function () {
        var _value = this.queryTypeCompliments.value;
        var _email = this.element.querySelector("input[name=email]");
        var _recipient = this.element.querySelector("input[name=recipient]");
        var _complaintsProcessWrap = this.element.querySelector(".complaints-process-wrapper");
        if (_value && _email && _recipient) {
            switch (_value) {
                case "COMPLAINT":
                    _email.value = "Complaints.CustomerRelations@standardbank.co.za";
                    _recipient.value = "Complaints.CustomerRelations@standardbank.co.za";
                    if (_complaintsProcessWrap) {
                        _complaintsProcessWrap.classList.remove("form__group--hidden");
                    }
                    break;
                case "COMPLIMENT":
                    _email.value = "Information@standardbank.co.za";
                    _recipient.value = "Information@standardbank.co.za";
                    if (_complaintsProcessWrap) {
                        _complaintsProcessWrap.classList.add("form__group--hidden");
                    }
                    break;
                case "SUGGESTION":
                    _email.value = "Information@standardbank.co.za";
                    _recipient.value = "Information@standardbank.co.za";
                    if (_complaintsProcessWrap) {
                        _complaintsProcessWrap.classList.add("form__group--hidden");
                    }
                    break;
                case "QUERY":
                    _email.value = "Information@standardbank.co.za";
                    _recipient.value = "Information@standardbank.co.za";
                    if (_complaintsProcessWrap) {
                        _complaintsProcessWrap.classList.add("form__group--hidden");
                    }
                    break;
                default:
                    _email.value = "Information@standardbank.co.za";
                    _recipient.value = "Information@standardbank.co.za";
                    if (_complaintsProcessWrap) {
                        _complaintsProcessWrap.classList.add("form__group--hidden");
                    }
                    break;
            }
        }
    };
    FormItemMailFormV2.prototype.populateFeedBackType = function () {
        var _this = this;
        if (this.feedbackTypeSelect && this.feedbackTypeData) {
            this.feedbackTypeSelect.innerHTML = "";
            this.feedbackTypeData.map(function (pFeedback) {
                var elem = _this.createOption(pFeedback);
                _this.feedbackTypeSelect.appendChild(elem);
            });
        }
    };
    FormItemMailFormV2.prototype.populateSubFeedBackType = function (pEvent) {
        var _this = this;
        if (pEvent === void 0) { pEvent = null; }
        if (pEvent === "") {
            this.resetSubSelect();
            this.resetSubSubSelect();
        }
        else {
            if (this.feedbackTypeSubSelect && this.feedbackTypeData) {
                this.feedbackTypeSubSelect.innerHTML = "";
                var _feedbackSub = this.feedbackTypeData.find(function (PFeedback) {
                    if (PFeedback.name === pEvent) {
                        return PFeedback;
                    }
                });
                if (_feedbackSub && _feedbackSub.children.length > 0) {
                    _feedbackSub.children.map(function (pCity) {
                        var elem = _this.createOption(pCity);
                        _this.feedbackTypeSubSelect.appendChild(elem);
                        _this.feedbackTypeSubSelect.classList.remove("form__input--required");
                        var _formGroup = _this.feedbackTypeSubSelect.closest(".form__group");
                        _formGroup.classList.remove("form__group--hidden");
                    });
                }
                else {
                    this.resetSubSelect();
                    this.resetSubSubSelect();
                }
            }
            else {
                this.resetSubSelect();
                this.resetSubSubSelect();
            }
        }
    };
    FormItemMailFormV2.prototype.populateSubSubFeedBackType = function (pEvent) {
        var _this = this;
        if (pEvent === void 0) { pEvent = null; }
        if (pEvent === "") {
            this.resetSubSubSelect();
        }
        else {
            if (this.feedbackTypeSubSubSelect && this.feedbackTypeData) {
                this.feedbackTypeSubSubSelect.innerHTML = "";
                var _feedbackSub = this.feedbackTypeData.find(function (PFeedback) {
                    if (PFeedback.name === _this.feedbackTypeSelect.value) {
                        return PFeedback;
                    }
                });
                if (_feedbackSub && _feedbackSub.children.length > 0) {
                    var _subSub = _feedbackSub.children.find(function (PFeedback) {
                        if (PFeedback.name === pEvent) {
                            return PFeedback;
                        }
                    });
                    if (_subSub && _subSub.children.length > 0) {
                        _subSub.children.map(function (pCity) {
                            var elem = _this.createOption(pCity);
                            _this.feedbackTypeSubSubSelect.appendChild(elem);
                            _this.feedbackTypeSubSubSelect.classList.remove("form__input--required");
                            var _formGroup = _this.feedbackTypeSubSubSelect.closest(".form__group");
                            _formGroup.classList.remove("form__group--hidden");
                        });
                    }
                    else {
                        this.resetSubSubSelect();
                    }
                }
                else {
                    this.resetSubSubSelect();
                }
            }
            else {
                this.resetSubSubSelect();
            }
        }
    };
    FormItemMailFormV2.prototype.resetSubSelect = function () {
        if (this.feedbackTypeSubSelect) {
            this.feedbackTypeSubSelect.innerHTML = "";
            var elem = document.createElement("option");
            elem.textContent = "Please select feedback type";
            elem.value = "";
            this.feedbackTypeSubSelect.appendChild(elem);
            this.feedbackTypeSubSelect.classList.remove("form__input--required");
            var _formGroup = this.feedbackTypeSubSelect.closest(".form__group");
            _formGroup.classList.add("form__group--hidden");
        }
    };
    FormItemMailFormV2.prototype.resetSubSubSelect = function () {
        if (this.feedbackTypeSubSubSelect) {
            this.feedbackTypeSubSubSelect.innerHTML = "";
            var elem = document.createElement("option");
            elem.textContent = "Please select feedback type";
            elem.value = "";
            this.feedbackTypeSubSubSelect.appendChild(elem);
            this.feedbackTypeSubSubSelect.classList.remove("form__input--required");
            var _formGroup = this.feedbackTypeSubSubSelect.closest(".form__group");
            _formGroup.classList.add("form__group--hidden");
        }
    };
    FormItemMailFormV2.prototype.createOption = function (pData) {
        var elem = document.createElement("option");
        elem.textContent = pData.name;
        if (pData.name !== "Please Select") {
            elem.value = pData.name;
        }
        else {
            elem.value = "";
        }
        return elem;
    };
    FormItemMailFormV2.prototype.updateEmailForNaturalResources = function (select) {
        var _subject = "Natural Resources - Mining Call Me Back";
        var _email = "naturalresources@standardbank.co.za";
        var _recipient = "naturalresources@standardbank.co.za";
        switch (select) {
            case "Oil and Gas":
                _subject = "Natural Resources - Oil and Gas Call Me Back";
                _email = "naturalresources@standardbank.co.za";
                _recipient = "naturalresources@standardbank.co.za,BCBSustainability@standardBank.co.za";
                break;
            case "Mining":
                _subject = "Natural Resources - Mining Call Me Back";
                _email = "naturalresources@standardbank.co.za";
                _recipient = "naturalresources@standardbank.co.za,BCBSustainability@standardBank.co.za";
                break;
            case "Renewable Energy":
                _subject = "Natural Resources - Renewable Energy Call Me Back";
                _email = "solarpv@standardbank.co.za";
                _recipient = "solarpv@standardbank.co.za,BCBSustainability@standardBank.co.za";
                break;
        }
        if (this.subjectField) {
            this.subjectField.value = _subject;
        }
        if (this.emailField) {
            this.emailField.value = _email;
        }
        if (this.recipientField) {
            this.recipientField.value = _recipient;
        }
        if (this.naturalResourcesProvinces &&
            this.naturalResourcesTypeOfSolution) {
            this.updateProvincesAndToSForNaturalResources(select);
        }
    };
    FormItemMailFormV2.prototype.updateProvincesAndToSForNaturalResources = function (select) {
        this.naturalResourcesProvincesContainer = this.element.querySelector(".js-help-required-province-container");
        this.naturalResourcesTypeOfSolutionContainer =
            this.element.querySelector(".js-help-required-tos-container");
        this.naturalResourcesTownContainer = this.element.querySelector(".js-help-required-town-container");
        if (this.naturalResourcesProvincesContainer &&
            this.naturalResourcesTypeOfSolutionContainer) {
            if (select === "Renewable Energy") {
                this.naturalResourcesProvincesContainer.classList.remove("form__group--hidden");
                this.naturalResourcesTypeOfSolutionContainer.classList.remove("form__group--hidden");
                this.naturalResourcesTownContainer.classList.remove("form__group--hidden");
            }
            else {
                this.naturalResourcesProvincesContainer.classList.add("form__group--hidden");
                this.naturalResourcesTypeOfSolutionContainer.classList.add("form__group--hidden");
                this.naturalResourcesTownContainer.classList.add("form__group--hidden");
                this.naturalResourcesProvinces.value = "";
                this.naturalResourcesTypeOfSolution.value = "";
                this.naturalResourcesTown.value = "";
            }
        }
    };
    FormItemMailFormV2.prototype.updateEmailForEstateAdministration = function (select) {
        var _subject = "Estate Administration \u2013 Estate Call Me Back";
        var _email = "StandardTrust@standardbank.co.za";
        var _recipient = "StandardTrust@standardbank.co.za";
        switch (select) {
            case "I have a query on an existing estate":
                _subject = "Estate Administration - Existing estate Call Me Back";
                _email = "StandardTrust@standardbank.co.za";
                _recipient = "StandardTrust@standardbank.co.za";
                this.analyticsService.dtmFormNameChange(select);
                break;
            case "I would like Standard Trust to serve as executor":
                _subject = "Estate Administration - Prospect estate Call Me Back";
                _email = "ContactSTL@standardbank.co.za";
                _recipient = "ContactSTL@standardbank.co.za";
                this.analyticsService.dtmFormNameChange(select);
                break;
        }
        if (this.subjectField) {
            this.subjectField.value = _subject;
        }
        if (this.emailField) {
            this.emailField.value = _email;
        }
        if (this.recipientField) {
            this.recipientField.value = _recipient;
        }
    };
    FormItemMailFormV2.prototype.updateEmailForTrust = function (select) {
        var _subject = "Trust - Call Me Back";
        var _email = "StandardTrust@standardbank.co.za";
        var _recipient = "StandardTrust@standardbank.co.za";
        switch (select) {
            case "I have a request regarding my existing Trust":
                _subject = "Trust - Existing Trust Call Me Back";
                _email = "StandardTrust@standardbank.co.za";
                _recipient = "StandardTrust@standardbank.co.za";
                this.analyticsService.dtmFormNameChange(select);
                break;
            case "I would like to set up a Trust":
                _subject = "Trust -  Prospect Trust Call Me Back";
                _email = "ContactSTL@standardbank.co.za";
                _recipient = "ContactSTL@standardbank.co.za";
                this.analyticsService.dtmFormNameChange(select);
                break;
        }
        if (this.subjectField) {
            this.subjectField.value = _subject;
        }
        if (this.emailField) {
            this.emailField.value = _email;
        }
        if (this.recipientField) {
            this.recipientField.value = _recipient;
        }
    };
    FormItemMailFormV2.prototype.updateEmailForWills = function (select) {
        this.analyticsService.dtmFormNameChange(select);
    };
    FormItemMailFormV2.prototype.updateCashSolutionsEmail = function () {
        if (this.recipientField) {
            this.emailField.value = "website@standardbank.co.za";
            switch (this.cashSolutionsProvince.value) {
                case "Gauteng":
                    this.recipientField.value = "Siva.Reddy@standardbank.co.za";
                    break;
                case "Eastern Cape":
                    this.recipientField.value = "ECBOL@standardbank.onmicrosoft.com";
                    break;
                case "Free State":
                    this.recipientField.value = "Natasha.May@standardbank.co.za";
                    break;
                case "Kwazulu Natal":
                    this.recipientField.value = "Stuart.Reeves@standardbank.co.za";
                    break;
                case "Limpopo":
                    this.recipientField.value = "Milne.Becker@standardbank.co.za";
                    break;
                case "Mpumalanga":
                    this.recipientField.value = "Julian.Felix@standardbank.co.za, Elma.Jordaan@standardbank.co.za";
                    break;
                case "North West":
                    this.recipientField.value = "Brenda.Magana@standardbank.co.za";
                    break;
                case "Northern Cape":
                    this.recipientField.value = "Nolwazi.Nkeane@standardbank.co.za";
                    break;
                case "Western Cape":
                    this.recipientField.value = "Louis.Visser@standardbank.co.za";
                    break;
                default:
                    this.recipientField.value = "cashsolutionssupport@standardbank.co.za";
                    break;
            }
        }
    };
    FormItemMailFormV2.prototype.updateDebtCareEmailAddress = function () {
        if (this.recipientField) {
            this.emailField.value = "website@standardbank.co.za";
            switch (this.debtCareAssistance.value) {
                case "Home Loans":
                    this.recipientField.value = "esleads@standardbank.co.za";
                    break;
                case "Overdraft":
                    this.recipientField.value = "SBSAPersonalCheque@standardbank.co.za";
                    break;
                case "Vehicles":
                    this.recipientField.value = "VAFSBSACommunications@standardbank.co.za";
                    break;
                case "Loans":
                    this.recipientField.value = "StandardBankPersonalLendingCollections@standardbank.co.za";
                    break;
                case "Credit Cards":
                    this.recipientField.value = "creditcardcommunications@standardbank.co.za";
                    break;
                case "Diners Club":
                    this.recipientField.value = "DinersClubCommunications@standardbank.co.za";
                    break;
                default:
                    this.recipientField.value = "debtcarecentre@standardbank.co.za";
                    break;
            }
        }
    };
    FormItemMailFormV2.prototype.submitGenericLead = function (form) {
        // success screens
        var loader = form.querySelector(".form__loader--container");
        var thankYou = form.querySelector(".form__thankyou--container");
        var fieldsContainer = form.querySelector(".form__fields--container");
        var _postData = "";
        // fields
        var _email = form.querySelector("input[name=email]");
        var _recipient = form.querySelector("input[name=recipient]");
        var _subject = form.querySelector("input[name=subject]");
        var _description = form.querySelector("input[name=description]");
        var _firstName = form.querySelector("input[name=first-name]");
        var _lastName = form.querySelector("input[name=last-name]");
        var _contactNumber = form.querySelector("input[name=contact-number]");
        var _emailAddress = form.querySelector("input[name=email-address]");
        var _nameTitle = form.querySelector("select[name=name-title]");
        var _tmpData = {
            email: _email ? _email.value : "",
            recipient: _recipient ? _recipient.value : "",
            subject: _subject ? _subject.value : "",
            description: _description ? _description.value : "",
            name: _firstName ? _firstName.value : "",
            surname: _lastName ? _lastName.value : "",
            "phone-number": _contactNumber ? _contactNumber.value : "",
            "email-address": _emailAddress ? _emailAddress.value : "",
            "name-title": _nameTitle ? _nameTitle.value : "",
        };
        _postData = this.http.serialiseObject(_tmpData);
        // loader + hide form
        loader.classList.add("active");
        fieldsContainer.classList.add("hidden");
        // variables
        var analyticsService = new AnalyticsService();
        var url = this.baseUrl + "/services/genericform.jsp";
        // service
        this.formsService
            .postForm(url, _postData)
            .then(function (response) {
            // service ok
            loader.classList.remove("active");
            analyticsService.dtmFormComplete("complete", "", false, "", _emailAddress.value, _contactNumber.value);
            thankYou.classList.add("active");
        })
            .catch(function (response) {
            // service failed
            analyticsService.dtmFormComplete("complete", "");
            loader.classList.remove("active");
            thankYou.classList.add("active");
        });
    };
    FormItemMailFormV2.prototype.submitNaturalResourceLead = function (form) {
        // success screens
        var loader = form.querySelector(".form__loader--container");
        var thankYou = form.querySelector(".form__thankyou--container");
        var fieldsContainer = form.querySelector(".form__fields--container");
        // fields
        var email = form.querySelector("input[name=email]");
        var recipient = form.querySelector("input[name=recipient]");
        var subject = form.querySelector("input[name=subject]");
        var product = form.querySelector("input[name=product]");
        var firstName = form.querySelector("input[name=first-name]");
        var surname = form.querySelector("input[name=surname]");
        var emailAddress = form.querySelector("input[name=email-address]");
        var contactNumber = form.querySelector("input[name=contact-number]");
        var helpRequiredTown = form.querySelector("input[name=help-required-town]");
        var selectedProvince = form.querySelector("select[name=selected-province]");
        var typeOfSolution = form.querySelector("select[name=type-of-solution]");
        var requiredAssistance = form.querySelector("textarea[name=required-assistance]");
        var popiaConsent = form.querySelector("input[name=popia-consent]");
        var _postData = {
            email: email ? email.value : "",
            recipient: recipient ? recipient.value : "",
            subject: subject ? subject.value : "",
            firstName: firstName ? firstName.value : "",
            lastName: surname ? surname.value : "",
            emailAddress: emailAddress ? emailAddress.value : "",
            contactNo: contactNumber ? contactNumber.value : "",
            province: selectedProvince ? selectedProvince.value : "",
            town: helpRequiredTown ? helpRequiredTown.value : "",
            typeOfSolution: typeOfSolution ? typeOfSolution.value : "",
            product: product ? product.value : "",
            comment: requiredAssistance ? requiredAssistance.value : "",
            dataPrivacyConsent: popiaConsent
                ? popiaConsent.checked
                    ? "YES"
                    : "NO"
                : "NO",
            dataSharingGroup: this.getDataConsentValue(form, "data-sharing-group"),
            dataSharing3rdParty: this.getDataConsentValue(form, "data-sharing-3rd-party"),
            dataSharingBoarders: this.getDataConsentValue(form, "data-sharing-boarders"),
        };
        // loader + hide form
        loader.classList.add("active");
        fieldsContainer.classList.add("hidden");
        var url = this.baseUrl + "/bcleadUtils/industry-natural-resources";
        var _config = {
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "X-Requested-With": "XMLHttpRequest",
            },
        };
        // variables
        var analyticsService = new AnalyticsService();
        // service
        this.formsService
            .postForm(url, _postData, _config)
            .then(function (response) {
            // service ok
            loader.classList.remove("active");
            analyticsService.dtmFormComplete("complete", "", false, "", emailAddress.value, contactNumber.value);
            thankYou.classList.add("active");
        })
            .catch(function (response) {
            // service failed
            analyticsService.dtmFormComplete("complete", "");
            loader.classList.remove("active");
            thankYou.classList.add("active");
        });
    };
    FormItemMailFormV2.prototype.submitForm = function (form) {
        var _type = form.querySelector("input[name=type]");
        console.log("_type", _type);
        console.log("_type.value", _type.value);
        if (_type && _type.value === "natural-resource") {
            this.submitNaturalResourceLead(form);
        }
        else {
            this.submitGenericLead(form);
        }
    };
    FormItemMailFormV2.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    FormItemMailFormV2.prototype.populateFeedbackTypeData = function () {
        this.feedbackTypeData = [
            {
                name: "Please Select",
            },
            {
                name: "Account in Arrears / Legal",
                children: [
                    {
                        name: "Please Select",
                    },
                    {
                        name: "Credit Card",
                        children: [
                            {
                                name: "Please Select",
                            },
                            {
                                name: "Dispute Arrears balance",
                            },
                            {
                                name: "Debt Collections Agent (Outsourced)",
                            },
                            {
                                name: "Debt Review",
                            },
                            {
                                name: "Documents request not actioned",
                            },
                            {
                                name: "Payment Arrangement",
                            },
                            {
                                name: "Received Arrears Communications",
                            },
                            {
                                name: "Unhappy with Legal process",
                            },
                            {
                                name: "Unhappy with Standard Bank collections process",
                            },
                            {
                                name: "Other",
                            },
                        ],
                    },
                    {
                        name: "Cheque Account",
                        children: [
                            {
                                name: "Please Select",
                            },
                            {
                                name: "Dispute Arrears balance",
                            },
                            {
                                name: "Debt Collections Agent (Outsourced)",
                            },
                            {
                                name: "Debt Review",
                            },
                            {
                                name: "Documents request not actioned",
                            },
                            {
                                name: "Payment Arrangement",
                            },
                            {
                                name: "Received Arrears Communications",
                            },
                            {
                                name: "Unhappy with Legal process",
                            },
                            {
                                name: "Unhappy with Standard Bank collections process",
                            },
                            {
                                name: "Other",
                            },
                        ],
                    },
                    {
                        name: "Home Loans",
                        children: [
                            {
                                name: "Please Select",
                            },
                            {
                                name: "Dispute Arrears balance",
                            },
                            {
                                name: "Debt Collections Agent (Outsourced)",
                            },
                            {
                                name: "Debt Review",
                            },
                            {
                                name: "Documents request not actioned",
                            },
                            {
                                name: "Payment Arrangement",
                            },
                            {
                                name: "Received Arrears Communications",
                            },
                            {
                                name: "Unhappy with Legal process",
                            },
                            {
                                name: "Unhappy with Standard Bank collections process",
                            },
                            {
                                name: "Other",
                            },
                        ],
                    },
                    {
                        name: "Insurance",
                        children: [
                            {
                                name: "Please Select",
                            },
                            {
                                name: "Dispute Arrears balance",
                            },
                            {
                                name: "Debt Collections Agent (Outsourced)",
                            },
                            {
                                name: "Debt Review",
                            },
                            {
                                name: "Documents request not actioned",
                            },
                            {
                                name: "Payment Arrangement",
                            },
                            {
                                name: "Received Arrears Communications",
                            },
                            {
                                name: "Unhappy with Legal process",
                            },
                            {
                                name: "Unhappy with Standard Bank collections process",
                            },
                            {
                                name: "Other",
                            },
                        ],
                    },
                    {
                        name: "Overdraft",
                        children: [
                            {
                                name: "Please Select",
                            },
                            {
                                name: "Dispute Arrears balance",
                            },
                            {
                                name: "Debt Collections Agent (Outsourced)",
                            },
                            {
                                name: "Debt Review",
                            },
                            {
                                name: "Documents request not actioned",
                            },
                            {
                                name: "Payment Arrangement",
                            },
                            {
                                name: "Received Arrears Communications",
                            },
                            {
                                name: "Unhappy with Legal process",
                            },
                            {
                                name: "Unhappy with Standard Bank collections process",
                            },
                            {
                                name: "Other",
                            },
                        ],
                    },
                    {
                        name: "Personal Loans",
                        children: [
                            {
                                name: "Please Select",
                            },
                            {
                                name: "Dispute Arrears balance",
                            },
                            {
                                name: "Debt Collections Agent (Outsourced)",
                            },
                            {
                                name: "Debt Review",
                            },
                            {
                                name: "Documents request not actioned",
                            },
                            {
                                name: "Payment Arrangement",
                            },
                            {
                                name: "Received Arrears Communications",
                            },
                            {
                                name: "Unhappy with Legal process",
                            },
                            {
                                name: "Unhappy with Standard Bank collections process",
                            },
                            {
                                name: "Other",
                            },
                        ],
                    },
                    {
                        name: "Vehicle Asset Finance",
                        children: [
                            {
                                name: "Please Select",
                            },
                            {
                                name: "Dispute Arrears balance",
                            },
                            {
                                name: "Debt Collections Agent (Outsourced)",
                            },
                            {
                                name: "Debt Review",
                            },
                            {
                                name: "Documents request not actioned",
                            },
                            {
                                name: "Payment Arrangement",
                            },
                            {
                                name: "Received Arrears Communications",
                            },
                            {
                                name: "Unhappy with Legal process",
                            },
                            {
                                name: "Unhappy with Standard Bank collections process",
                            },
                            {
                                name: "Other",
                            },
                        ],
                    },
                ],
            },
            {
                name: "Card",
                children: [
                    {
                        name: "Please Select",
                    },
                    {
                        name: "Applications",
                    },
                    {
                        name: "Card Delivery / Renewal",
                    },
                    {
                        name: "Closing of Account",
                    },
                    {
                        name: "Debit Order",
                    },
                    {
                        name: "Dispute balance",
                    },
                    {
                        name: "Documents request not actioned",
                    },
                    {
                        name: "Fees / Interest / Pricing",
                    },
                    {
                        name: "International Use",
                    },
                    {
                        name: "Limit Changes",
                    },
                    {
                        name: "Other",
                    },
                ],
            },
            {
                name: "Fraud",
                children: [
                    {
                        name: "Please Select",
                    },
                    {
                        name: "ATM Fraud",
                        children: [
                            {
                                name: "Please Select",
                            },
                            {
                                name: "Claim declined",
                            },
                            {
                                name: "Delay in finalising claim",
                            },
                            {
                                name: "No feedback on Claim lodged",
                            },
                            {
                                name: "Unhappy with partial payment offered",
                            },
                            {
                                name: "Other",
                            },
                        ],
                    },
                    {
                        name: "Card Fraud",
                        children: [
                            {
                                name: "Please Select",
                            },
                            {
                                name: "Claim declined",
                            },
                            {
                                name: "Delay in finalising claim",
                            },
                            {
                                name: "No feedback on Claim lodged",
                            },
                            {
                                name: "Unhappy with partial payment offered",
                            },
                            {
                                name: "Other",
                            },
                        ],
                    },
                    {
                        name: "Online Fraud",
                        children: [
                            {
                                name: "Please Select",
                            },
                            {
                                name: "Claim declined",
                            },
                            {
                                name: "Delay in finalising claim",
                            },
                            {
                                name: "No feedback on Claim lodged",
                            },
                            {
                                name: "Unhappy with partial payment offered",
                            },
                            {
                                name: "Other",
                            },
                        ],
                    },
                    {
                        name: "Transactional Fraud",
                        children: [
                            {
                                name: "Please Select",
                            },
                            {
                                name: "Claim declined",
                            },
                            {
                                name: "Delay in finalising claim",
                            },
                            {
                                name: "No feedback on Claim lodged",
                            },
                            {
                                name: "Unhappy with partial payment offered",
                            },
                            {
                                name: "Other",
                            },
                        ],
                    },
                ],
            },
            {
                name: "Home Loans",
                children: [
                    {
                        name: "Please Select",
                    },
                    {
                        name: "Access Bond",
                    },
                    {
                        name: "Applications",
                    },
                    {
                        name: "Assurance",
                    },
                    {
                        name: "Attorney",
                    },
                    {
                        name: "Building Loan",
                    },
                    {
                        name: "Closing / Cancelling of Home Loan",
                    },
                    {
                        name: "Debit Order",
                    },
                    {
                        name: "Dispute balance",
                    },
                    {
                        name: "Documents request not actioned",
                    },
                    {
                        name: "Fees / Interest / Pricing",
                    },
                    {
                        name: "Progress payments",
                    },
                    {
                        name: "Other",
                    },
                ],
            },
            {
                name: "Insurance",
                children: [
                    {
                        name: "Please Select",
                    },
                    {
                        name: "Claim declined",
                    },
                    {
                        name: "Delay in finalising claim",
                    },
                    {
                        name: "No feedback on Claim lodged",
                    },
                    {
                        name: "Unhappy with Claim outcome",
                    },
                    {
                        name: "Other",
                    },
                ],
            },
            {
                name: "Investment / Savings",
                children: [
                    {
                        name: "Please Select",
                    },
                    {
                        name: "Applications",
                    },
                    {
                        name: "Closing of Account",
                    },
                    {
                        name: "Debit Order",
                    },
                    {
                        name: "Dispute balance",
                    },
                    {
                        name: "Documents request not actioned",
                    },
                    {
                        name: "Fees / Interest / Pricing",
                    },
                    {
                        name: "Funds not in investment account",
                    },
                    {
                        name: "Poor advice on investment",
                    },
                    {
                        name: "Other",
                    },
                ],
            },
            {
                name: "Standard Executors and Trustees",
                children: [
                    {
                        name: "Please Select",
                    },
                    {
                        name: "Closing of Account",
                    },
                    {
                        name: "Delay in finalising of estate",
                    },
                    {
                        name: "Delay in receiving feedback",
                    },
                    {
                        name: "Delay in receiving payment",
                    },
                    {
                        name: "Delay in terminating matter",
                    },
                    {
                        name: "Dispute with Trustee decisions",
                    },
                    {
                        name: "Distribution Payments Outstanding",
                    },
                    {
                        name: "Wills",
                    },
                    {
                        name: "Other",
                    },
                ],
            },
            {
                name: "Transactional",
                children: [
                    {
                        name: "Please Select",
                    },
                    {
                        name: "Access Loan",
                        children: [
                            {
                                name: "Please Select",
                            },
                            {
                                name: "Applications / Sales",
                            },
                            {
                                name: "Closing of Account",
                            },
                            {
                                name: "Debit Order",
                            },
                            {
                                name: "Dispute balance",
                            },
                            {
                                name: "Documents request not actioned",
                            },
                            {
                                name: "Fees / Interest / Pricing",
                            },
                            {
                                name: "Forex",
                            },
                            {
                                name: "Inward / Outward Payments",
                            },
                            {
                                name: "Limit Changes",
                            },
                            {
                                name: "Reversal / Refund not actioned",
                            },
                            {
                                name: "Other",
                            },
                        ],
                    },
                    {
                        name: "Cheque Account",
                        children: [
                            {
                                name: "Please Select",
                            },
                            {
                                name: "Applications / Sales",
                            },
                            {
                                name: "Closing of Account",
                            },
                            {
                                name: "Debit Order",
                            },
                            {
                                name: "Dispute balance",
                            },
                            {
                                name: "Documents request not actioned",
                            },
                            {
                                name: "Fees / Interest / Pricing",
                            },
                            {
                                name: "Forex",
                            },
                            {
                                name: "Inward / Outward Payments",
                            },
                            {
                                name: "Limit Changes",
                            },
                            {
                                name: "Reversal / Refund not actioned",
                            },
                            {
                                name: "Other",
                            },
                        ],
                    },
                    {
                        name: "International Payments",
                        children: [
                            {
                                name: "Please Select",
                            },
                            {
                                name: "Applications / Sales",
                            },
                            {
                                name: "Closing of Account",
                            },
                            {
                                name: "Debit Order",
                            },
                            {
                                name: "Dispute balance",
                            },
                            {
                                name: "Documents request not actioned",
                            },
                            {
                                name: "Fees / Interest / Pricing",
                            },
                            {
                                name: "Forex",
                            },
                            {
                                name: "Inward / Outward Payments",
                            },
                            {
                                name: "Limit Changes",
                            },
                            {
                                name: "Reversal / Refund not actioned",
                            },
                            {
                                name: "Other",
                            },
                        ],
                    },
                    {
                        name: "Overdraft",
                        children: [
                            {
                                name: "Please Select",
                            },
                            {
                                name: "Applications / Sales",
                            },
                            {
                                name: "Closing of Account",
                            },
                            {
                                name: "Debit Order",
                            },
                            {
                                name: "Dispute balance",
                            },
                            {
                                name: "Documents request not actioned",
                            },
                            {
                                name: "Fees / Interest / Pricing",
                            },
                            {
                                name: "Forex",
                            },
                            {
                                name: "Inward / Outward Payments",
                            },
                            {
                                name: "Limit Changes",
                            },
                            {
                                name: "Reversal / Refund not actioned",
                            },
                            {
                                name: "Other",
                            },
                        ],
                    },
                    {
                        name: "Personal Loans",
                        children: [
                            {
                                name: "Please Select",
                            },
                            {
                                name: "Applications / Sales",
                            },
                            {
                                name: "Closing of Account",
                            },
                            {
                                name: "Debit Order",
                            },
                            {
                                name: "Dispute balance",
                            },
                            {
                                name: "Documents request not actioned",
                            },
                            {
                                name: "Fees / Interest / Pricing",
                            },
                            {
                                name: "Forex",
                            },
                            {
                                name: "Inward / Outward Payments",
                            },
                            {
                                name: "Limit Changes",
                            },
                            {
                                name: "Reversal / Refund not actioned",
                            },
                            {
                                name: "Other",
                            },
                        ],
                    },
                    {
                        name: "Revolving Credit Plan",
                        children: [
                            {
                                name: "Please Select",
                            },
                            {
                                name: "Applications / Sales",
                            },
                            {
                                name: "Closing of Account",
                            },
                            {
                                name: "Debit Order",
                            },
                            {
                                name: "Dispute balance",
                            },
                            {
                                name: "Documents request not actioned",
                            },
                            {
                                name: "Fees / Interest / Pricing",
                            },
                            {
                                name: "Forex",
                            },
                            {
                                name: "Inward / Outward Payments",
                            },
                            {
                                name: "Limit Changes",
                            },
                            {
                                name: "Reversal / Refund not actioned",
                            },
                            {
                                name: "Other",
                            },
                        ],
                    },
                    {
                        name: "Savings Account",
                        children: [
                            {
                                name: "Please Select",
                            },
                            {
                                name: "Applications / Sales",
                            },
                            {
                                name: "Closing of Account",
                            },
                            {
                                name: "Debit Order",
                            },
                            {
                                name: "Dispute balance",
                            },
                            {
                                name: "Documents request not actioned",
                            },
                            {
                                name: "Fees / Interest / Pricing",
                            },
                            {
                                name: "Forex",
                            },
                            {
                                name: "Inward / Outward Payments",
                            },
                            {
                                name: "Limit Changes",
                            },
                            {
                                name: "Reversal / Refund not actioned",
                            },
                            {
                                name: "Other",
                            },
                        ],
                    },
                    {
                        name: "Student Loan",
                        children: [
                            {
                                name: "Please Select",
                            },
                            {
                                name: "Applications / Sales",
                            },
                            {
                                name: "Closing of Account",
                            },
                            {
                                name: "Debit Order",
                            },
                            {
                                name: "Dispute balance",
                            },
                            {
                                name: "Documents request not actioned",
                            },
                            {
                                name: "Fees / Interest / Pricing",
                            },
                            {
                                name: "Forex",
                            },
                            {
                                name: "Inward / Outward Payments",
                            },
                            {
                                name: "Limit Changes",
                            },
                            {
                                name: "Reversal / Refund not actioned",
                            },
                            {
                                name: "Other",
                            },
                        ],
                    },
                ],
            },
            {
                name: "Vehicle and Asset Finance",
                children: [
                    {
                        name: "Please Select",
                    },
                    {
                        name: "Applications / Sales",
                    },
                    {
                        name: "Closing of Account",
                    },
                    {
                        name: "Debit Order",
                    },
                    {
                        name: "Dispute balance",
                    },
                    {
                        name: "Documents request not actioned",
                    },
                    {
                        name: "Fees / Interest / Pricing",
                    },
                    {
                        name: "Insurance added to instalment",
                    },
                    {
                        name: "Reversal / Refund not actioned",
                    },
                    {
                        name: "Unhappy with dealer/vehicle",
                    },
                    {
                        name: "Other",
                    },
                ],
            },
            {
                name: "Digital Banking",
                children: [
                    {
                        name: "Please Select",
                    },
                    {
                        name: "Internet Banking (IB)",
                    },
                    {
                        name: "Standard Bank App (App)",
                    },
                    {
                        name: "My-Updates (SMS)",
                    },
                ],
            },
            {
                name: "Service Related",
                children: [
                    {
                        name: "Please Select",
                    },
                    {
                        name: "Branch",
                        children: [
                            {
                                name: "Please Select",
                            },
                            {
                                name: "Staff Behaviour",
                            },
                            {
                                name: "Staff Knowledge",
                            },
                            {
                                name: "Premises",
                            },
                            {
                                name: "Other",
                            },
                        ],
                    },
                    {
                        name: "Contact Centre",
                        children: [
                            {
                                name: "Please Select",
                            },
                            {
                                name: "Staff Behaviour",
                            },
                            {
                                name: "Staff Knowledge",
                            },
                            {
                                name: "Premises",
                            },
                            {
                                name: "Other",
                            },
                        ],
                    },
                    {
                        name: "Private Banking",
                        children: [
                            {
                                name: "Please Select",
                            },
                            {
                                name: "Staff Behaviour",
                            },
                            {
                                name: "Staff Knowledge",
                            },
                            {
                                name: "Premises",
                            },
                            {
                                name: "Other",
                            },
                        ],
                    },
                    {
                        name: "Prestige Banking",
                        children: [
                            {
                                name: "Please Select",
                            },
                            {
                                name: "Staff Behaviour",
                            },
                            {
                                name: "Staff Knowledge",
                            },
                            {
                                name: "Premises",
                            },
                            {
                                name: "Other",
                            },
                        ],
                    },
                    {
                        name: "Standard Bank Insurance Brokers",
                        children: [
                            {
                                name: "Please Select",
                            },
                            {
                                name: "Staff Behaviour",
                            },
                            {
                                name: "Staff Knowledge",
                            },
                            {
                                name: "Premises",
                            },
                            {
                                name: "Other",
                            },
                        ],
                    },
                    {
                        name: "Business Banking",
                        children: [
                            {
                                name: "Please Select",
                            },
                            {
                                name: "Staff Behaviour",
                            },
                            {
                                name: "Staff Knowledge",
                            },
                            {
                                name: "Premises",
                            },
                            {
                                name: "Other",
                            },
                        ],
                    },
                    {
                        name: "Liberty",
                        children: [
                            {
                                name: "Please Select",
                            },
                            {
                                name: "Staff Behaviour",
                            },
                            {
                                name: "Staff Knowledge",
                            },
                            {
                                name: "Premises",
                            },
                            {
                                name: "Other",
                            },
                        ],
                    },
                    {
                        name: "Stanlib",
                        children: [
                            {
                                name: "Please Select",
                            },
                            {
                                name: "Staff Behaviour",
                            },
                            {
                                name: "Staff Knowledge",
                            },
                            {
                                name: "Premises",
                            },
                            {
                                name: "Other",
                            },
                        ],
                    },
                    {
                        name: "Forex",
                        children: [
                            {
                                name: "Please Select",
                            },
                            {
                                name: "Staff Behaviour",
                            },
                            {
                                name: "Staff Knowledge",
                            },
                            {
                                name: "Premises",
                            },
                            {
                                name: "Other",
                            },
                        ],
                    },
                ],
            },
            {
                name: "ATM",
                children: [
                    {
                        name: "Please Select",
                    },
                    {
                        name: "ATM Maintenance",
                    },
                    {
                        name: "Claim declined",
                    },
                    {
                        name: "Delay in finalising claim",
                    },
                    {
                        name: "Deposit not reflecting / retracted",
                    },
                    {
                        name: "No feedback on Claim lodged",
                    },
                    {
                        name: "Other Bank ATM",
                    },
                    {
                        name: "Withdrawal not received / short paid",
                    },
                    {
                        name: "Other",
                    },
                ],
            },
            {
                name: "Unwarranted Marketing",
                children: [
                    {
                        name: "Please Select",
                    },
                    {
                        name: "Did not request marketing",
                    },
                    {
                        name: "Request to update personal details not actioned",
                    },
                    {
                        name: "Receiving calls",
                    },
                    {
                        name: "Other",
                    },
                ],
            },
            {
                name: "UCount Rewards",
                children: [
                    {
                        name: "Please Select",
                    },
                    {
                        name: "Ucount card not linked",
                    },
                    {
                        name: "Ucount points balance incorrect",
                    },
                    {
                        name: "Ucount points not calculated correctly",
                    },
                    {
                        name: "Ucount registration",
                    },
                    {
                        name: "Ucount tier not updated",
                    },
                    {
                        name: "Other",
                    },
                ],
            },
        ];
    };
    return FormItemMailFormV2;
}(Base));
export { FormItemMailFormV2 };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-mail-form-v2/form-item-mail-form-v2.component.ts
// module id = 1043
// module chunks = 0